import { useRef, useState, useCallback } from 'react';
import type { SyntheticEvent } from 'react';

type VideoEvent = SyntheticEvent<HTMLVideoElement>;

type UseNativeVideoParams = {
  onPlay?: (event: VideoEvent) => void;
  onPause?: (event: VideoEvent) => void;
};

export function useNativeVideo({ onPlay, onPause }: UseNativeVideoParams = {}) {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [showPlayOverlay, setShowPlayOverlay] = useState(true);
  const [hasStartedPlayback, setHasStartedPlayback] = useState(false);

  const handlePlayClick = useCallback(() => {
    if (videoRef.current) {
      videoRef.current.play();
    }

    setShowPlayOverlay(false);
  }, []);

  const handleVideoPause = useCallback(
    (event: VideoEvent) => {
      setShowPlayOverlay(true);

      if (onPause) {
        onPause(event);
      }
    },
    [onPause],
  );

  const handleVideoPlay = useCallback(
    (event: VideoEvent) => {
      setHasStartedPlayback(true);
      setShowPlayOverlay(false);

      if (onPlay) {
        onPlay(event);
      }
    },
    [onPlay],
  );

  return {
    videoRef,
    showPlayOverlay,
    hasStartedPlayback,
    handlePlayClick,
    handleVideoPause,
    handleVideoPlay,
  };
}
